import React, { Component } from 'react';
import Parse from 'parse';
import { Link } from "react-router-dom";
import { getUrlVariable } from './utilities';
import { propertyOptions } from './propertyConfig'
import SearchFilter from './components/searchFilter'

export default class Units extends Component {
  constructor(props) {
      super(props);
      this.state = {
        list:[],
        value:""
      }
  }

  componentDidMount = () =>{
      var Query = Parse.Object.extend("Units");
      var query = new Parse.Query(Query);
      query.ascending("unit");
      query.limit(1000);
      query.find({
        success:(results) => {
            this.setState({
              'list':results,
              'fullResults':results
            })
        },
        error: function(error) {
            console.log("Error: " + error.code + " " + error.message);
        }
    })
  }
  showDetail = (id) =>{
    var fullResults = this.state.fullResults;
    for (var i = 0; i < fullResults.length; i++) {
      if(id == fullResults[i].id){
        var selectedUnit = {};
        selectedUnit.id = fullResults[i].id
        selectedUnit.attributes = fullResults[i].attributes
        this.setState({
          selectedUnit:selectedUnit,
          filteredSelectedUnit:selectedUnit
        })
        document.getElementById('detail-overlay').classList.add('active')
      }
    }
  }
  formatTrueFalse = (value) =>{
    var formattedValue = "";
    if(value == true){
      formattedValue = "Yes"
    } else if(value == false){
      formattedValue = "No"
    } else{
      formattedValue = value
    }
    return formattedValue
  }
  hideDetail = () =>{
    this.setState({
      selectedUnit:null,
      filteredSelectedUnit:null
    })
    document.getElementById('detail-overlay').classList.remove('active')
  }
  updateValue = (key,value) =>{
    var val = value;
    if(value == "true"){
      val = this.formatTrueFalse(true)
    }
    if(value == "false"){
      val = this.formatTrueFalse(false)
    }
    if(value == "All"){
      val = undefined
    }
    this.setState({
      [key]:val
    },()=>{
      this.search(this.state.value)
    })
  }
  highlightText = (text,value) => {
    var index = text.indexOf(value);
    return '<span>' + text.substring(0,index) + "<span class='highlight'>" + text.substring(index,index+text.length) + "</span>" + text.substring(index + text.length)+'</span>';
  }
  search = (value) =>{
    if (typeof value !== "boolean"){
       value = value.toLowerCase();
    }
    var searchResults = [];
    var fullResults = this.state.fullResults;
    for (var i = 0; i < fullResults.length; i++) {
      var result = fullResults[i];
      searchResults.push({
        id:result.id,
        attributes:result.attributes
      })
    }
    var filteredResults = [];
    for (var i = 0; i < searchResults.length; i++) {
      //Plain Text Search
      var matches = [];
      var results = [];
      var name = false;
      if(!value){
        filteredResults.push(searchResults[i]);
      }
      for (var x = 0; x < propertyOptions.length; x++) {
        if(value){
          var visualKey = propertyOptions[x].key;
          var primaryKey = propertyOptions[x].value;
          var secondaryKey = propertyOptions[x].description;
          var booleanKey = propertyOptions[x].isBoolean;
          var keywords = propertyOptions[x].keywords;
          var selectFilter = propertyOptions[x].selectFilter;

          // Check Boolean for search lengths greater than 2
          if(booleanKey && keywords && value.length > 2){
            var filteredKeywords = keywords.filter(result => result.indexOf(value) != -1);
            if(filteredKeywords.length > 0){
              matches.push({name:visualKey,value:searchResults[i].attributes[primaryKey]})
              results.push(primaryKey)
            }
          }

          // Check names for search lengths greater than 2
          else if(searchResults[i].attributes[primaryKey] && value.length > 2){
            if(searchResults[i].attributes[primaryKey].toLowerCase().indexOf(value) != -1){
              matches.push({name:visualKey,value:searchResults[i].attributes[primaryKey]})
              results.push(primaryKey)
            }
          }

          // Check descriptions for search lengths greater than 2
          if(searchResults[i].attributes[secondaryKey] && value.length > 2){
            if(searchResults[i].attributes[secondaryKey].toLowerCase().indexOf(value) != -1){
              matches.push({name:visualKey+" Description",value:searchResults[i].attributes[secondaryKey]})
              results.push(secondaryKey)
            }
          }

          if(results.length > 0){
            searchResults[i].matches = matches;
            filteredResults.push(searchResults[i]);
          }
        }

        if(i == searchResults.length -1){
          for (var i = 0; i < searchResults.length; i++) {
            for (var x = 0; x < propertyOptions.length; x++) {
              var visualKey = propertyOptions[x].key;
              var primaryKey = propertyOptions[x].value;
              var secondaryKey = propertyOptions[x].description;
              var booleanKey = propertyOptions[x].isBoolean;
              var keywords = propertyOptions[x].keywords;
              var selectFilter = propertyOptions[x].selectFilter;
              if(selectFilter){
                if(this.state[primaryKey] && this.state[primaryKey] !== undefined && this.state[primaryKey] !== ""){
                  if(booleanKey){
                    filteredResults = filteredResults.filter(result => this.formatTrueFalse(result.attributes[primaryKey]) === this.state[primaryKey]);
                  } else{
                    filteredResults = filteredResults.filter(result => result.attributes[primaryKey] && result.attributes[primaryKey].toLowerCase() === this.state[primaryKey].toLowerCase());
                  }
                }
              }
            }
            if(i == searchResults.length -1){
              var uniqueArray = [];
              var dedeupedArray = [];
              for (var y = 0; y < filteredResults.length; y++) {
                if(uniqueArray.indexOf(filteredResults[y].id) == -1){
                  dedeupedArray.push(filteredResults[y]);
                  uniqueArray.push(filteredResults[y].id);
                }
              }
              this.setState({
               list:dedeupedArray,
               value:value
             })

            }
          }
        }
      }
    }
  }
  filterDetail = (value) =>{
    var selectedUnit = this.state.selectedUnit;
    if(!value){
      this.setState({
        filteredSelectedUnit:selectedUnit
      })
    } else{
      var Obj = {};
      var array = Object.keys(selectedUnit.attributes);
      console.log(array)
      for (var i = 0; i < array.length; i++) {
        if(array[i].indexOf(value) != -1){
          Obj[array[i]] = selectedUnit.attributes[array[i]]
        } else if(selectedUnit.attributes[array[i]]){
          if(selectedUnit.attributes[array[i]]){
            if(typeof selectedUnit.attributes[array[i]] == 'string'){
              console.log(selectedUnit.attributes[array[i]])
              if(selectedUnit.attributes[array[i]].toLowerCase().indexOf(value.toLowerCase()) != -1){
                Obj[array[i]] = selectedUnit.attributes[array[i]]
              }
            }
          }
        }
      }
      var unitDetails = {}
      unitDetails.id = selectedUnit.id;
      unitDetails.attributes = Obj;
      this.setState({
        filteredSelectedUnit:unitDetails
      })
    }
  }
  showMobileFilters = () =>{
    document.getElementById('filter-options').classList.add('active')
  }
  hideMobileFilters = () =>{
    document.getElementById('filter-options').classList.remove('active')
  }
  refresh = () =>{
    window.location.reload()
  }

  render() {
    var notAdmin = false;
    if(Parse.User.current().id != "sr6v7szBOQ"){
      notAdmin = true
    }
    return (
      <div className="light-grey-background full-width" style={{position:'absolute', top:0, left:0, zIndex:100, height:"100%",  width:"100%", overflow:"hidden"}}>
        <div id="detail-overlay" className="overlay light-grey-background " style={{display:"flex", flexDirection:"column", height:"100%", width:"100%", zIndex:"100000", position:"absolute"}}>
          {this.state.selectedUnit &&
            <div>
              <div className="primary-background shadow">
                <div className="small-padding">
                  <div className="row">
                    <div className="small-12 medium-2">
                      <h1 className="white small-padding" style={{margin:'0px', fontSize:"50px", color:"#fff"}}>{this.state.selectedUnit.attributes.unit}</h1>
                    </div>
                    <div className="small-10 medium-8 row">
                      <input type="text" className="category-search full-width" style={{marginTop:0, padding:"20px", alignSelf:"center"}} onChange={(e) => this.filterDetail(e.target.value)} placeholder="search..." />
                    </div>
                    <div className="small-2 medium-2 right-text" style={{display:"flex", alignItems:"center", justifyContent:"flex-end"}}>
                      <img onClick={this.hideDetail} className="close-icon" src="/img/close-white.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="small-padding scroll-page" style={{flex:1}}>
                <div className="max-width-container">
                  <div className="row">
                    {propertyOptions.map((data,index) =>{
                      return(
                        <div className="small-12 medium-12 large-12 row">
                          <div className="tiny-padding full-width" style={{height:'100%'}}>
                            <div className="white-background small-padding" style={{height:'100%'}}>
                              <div>
                                <h2>{data.key}</h2>
                                <div>
                                  {(this.state.filteredSelectedUnit.attributes[data.value] === true && data.isBoolean) &&
                                    <p className="black-color" style={{opacity:".7", margin:"0"}}>{data.key+": "+this.formatTrueFalse(this.state.filteredSelectedUnit.attributes[data.value])}</p>
                                  }
                                  {(this.state.filteredSelectedUnit.attributes[data.value] === false && data.isBoolean) &&
                                    <p className="black-color" style={{opacity:".7", margin:"0"}}>{data.key+": "+this.formatTrueFalse(this.state.filteredSelectedUnit.attributes[data.value])}</p>
                                  }
                                  {(this.state.filteredSelectedUnit.attributes[data.value] && data.isBoolean != true) &&
                                    <p className="black-color" style={{opacity:".7", margin:"0"}}>{data.key+": "+this.state.filteredSelectedUnit.attributes[data.value]}</p>
                                  }
                                  {(this.state.filteredSelectedUnit.attributes[data.value] == undefined && data.isBoolean == true) &&
                                    <p className="black-color" style={{opacity:".7", margin:"0"}}>{data.key+": ?"}</p>
                                  }
                                  {this.state.filteredSelectedUnit.attributes[data.description] &&
                                    <p  className="black-color" style={{opacity:".7", margin:"0", whiteSpace:"pre-wrap" }}>{this.state.filteredSelectedUnit.attributes[data.description]}</p>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div style={{display:"flex", flexDirection:"column", height:"100%", width:"100%", overflow:"hidden"}}>
          <div className="tiny-padding primary-background">
            <div style={{position:'absolute',zIndex:10000, top:10, right:20}}>
              <a target="_blank" href="https://www.aperfectvacationrental.com/map-puamana" style={{margin:20, color:"#fff"}}>Map</a>
              {!notAdmin && <Link id="edit-link" to={'/units'} style={{margin:20, color:"#fff"}}>Edit</Link>}
              <div id="edit-link" onClick={this.props.logOutUser} style={{margin:20, color:"#fff", cursor:"pointer"}}>Logout</div>
            </div>
            <div id="mobile-filter-options-toggle" className="primary-background" onClick={this.showMobileFilters}>{'Filters'}</div>
            <div className="centered-text" style={{padding:"10px"}}>
              <img className="half-width" src="/img/logo.png" onClick={this.refresh} alt="Alpine" style={{maxWidth:"150px", cursor:"pointer"}} />
            </div>
            <input type="text" className="category-search full-width" style={{marginTop:0, padding:"15px"}} onChange={(e) => this.search(e.target.value)} placeholder="search..." />
          </div>
          <div className="primary-background full-width">
            <div className="primary-background" id="filter-options">
              <div id="mobile-filter-header">
                <img onClick={this.hideMobileFilters} className="close-icon" src="/img/close-white.png" style={{position:"absolute", right:"10px", top:"10px"}} />
                <h2 style={{color:"#fff"}}>{'Filters'}</h2>
              </div>
              {propertyOptions && propertyOptions.map((option) =>{
                if(option.selectFilter && option.selectOptions){
                  return(
                    <SearchFilter options={option.selectOptions} targetKey={option.value} title={option.key} value={this.state[option.value]} updateValue={this.updateValue} />
                  )
                }
              })}
            </div>
          </div>
          <div id="search-results" className="tiny-padding scroll-page" style={{flex:1}}>
            <div className="row">
              {this.state.list.map((item,index) => {
                return (
                  <div onClick={()=>{this.showDetail(item.id)}} style={{cursor:"pointer", display:"flex"}}  className="small-12 medium-4 large-3">
                    <div className="small-padding full-width" style={{display:"flex"}}>
                      <div className="white-background full-width" key={item.id} style={{borderRadius:"4px", boxShadow:"0px 6px 10px rgba(0,0,0,.075)",display:"flex"}}>
                        <div>
                          <div className="large-padding full-width">
                            <h2 className="black-color" style={{margin:'0px'}}>{item.attributes.unit}</h2>
                            {this.state.value == ""  &&
                              <p className="black-color" style={{opacity:".7", margin:"0"}}>{item.attributes.propertyLocation}</p>
                            }
                            {this.state.value != "" &&
                              <div className="row">
                                {item.matches && item.matches.map(function(match,index) {
                                  return(
                                    <div style={{padding:'10px'}}>
                                      <div style={{padding:'10px', backgroundColor:"#f9f9f9"}}>
                                        <p className="black-color" style={{opacity:".7", margin:"0"}}>{match.value}</p>
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/search.js